import React from 'react';
import PropTypes from 'prop-types';

import OverrideButton from './override_button';
import { Row, Col } from 'react-bootstrap';

function RadioInput({ checked, disabled, onChange, name }) {
  return (
    <div className="radio">
      <label>
        <input
          checked={checked}
          className="mr-2"
          disabled={disabled}
          name={name}
          type="radio"
          onChange={onChange}
        /> {name}
      </label>
    </div>
  );
}

RadioInput.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default function PageTemplateStyleSelector({ pageTemplateStyleId, pageTemplateStyles, onUpdate, onRemove }) {
  const disabled = !pageTemplateStyleId;
  return (
    <Row className="row-eq-height">
      <Col md={6} xs={8}>
        <div className="form-group grow mb-0">
          <div className="d-flex m-0 row">
            <div className="p-0 col-xs-3">
              <div className="control-label w-100 h-100">
                <label>Page Layout</label>
              </div>
            </div>
            <div className={`border col-xs-9 ${disabled ? 'd-flex align-items-center' : ''}`}>
              {disabled && (
                <span className="text-muted">Buildout Default</span>
              )}
              {!disabled && pageTemplateStyles.map(layout => (
                <RadioInput
                  checked={pageTemplateStyleId == layout.identifier}
                  disabled={disabled}
                  key={layout.name}
                  name={layout.name}
                  onChange={() => onUpdate(layout)}
                />
              ))}
            </div>
          </div>
        </div>
      </Col>
      <Col md={6} xs={4}>
        <OverrideButton
          disabled={disabled}
          onRemove={onRemove}
          onReset={() => onUpdate(pageTemplateStyles[0])}
        />
      </Col>
    </Row>
  );
}

PageTemplateStyleSelector.propTypes = {
  pageTemplateStyleId: PropTypes.string,
  pageTemplateStyles: PropTypes.arrayOf(PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
